import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { DEVICES } from './OverlayToolbar';
import PreviewFrame from './PreviewFrame';
import './preview.css';

// Read-only stubs: no editing, approval, comments, terms, or status overlays for
// external viewers — just the rendered reading view.
const READONLY_MUTATIONS = { overrides: {}, busy: null, saveTranslation: undefined, toggleApprove: undefined };
const READONLY_REFERENCE = { matchers: [], commentCounts: {}, getThread: undefined };
const READONLY_OVERLAYS = {
    showSource: false, showStatus: false, showOverflow: true,
    showConfidence: false, showTerms: false, showPseudo: false,
};

const SharedPreview = () => {
    const { token } = useParams();
    const [preview, setPreview] = useState(null);
    const [device, setDevice] = useState('desktop');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!token) return;
        axios
            .get(`/api/shared-preview/${encodeURIComponent(token)}`)
            .then((r) => { setPreview(r.data); setLoading(false); })
            .catch((err) => {
                setError(err.response?.data?.msg || 'This preview link is not available.');
                setLoading(false);
            });
    }, [token]);

    const deviceWidth = DEVICES.find((d) => d.id === device).width;
    const proj = preview?.project;
    const groups = preview?.groups || [];

    if (loading) return <div style={{ padding: 40, color: '#666', fontFamily: 'system-ui, sans-serif' }}>Loading preview…</div>;
    if (error) return <div style={{ padding: 40, color: 'crimson', fontFamily: 'system-ui, sans-serif' }}>{error}</div>;

    return (
        <div style={{ maxWidth: 1360, margin: '0 auto', padding: '24px 20px', fontFamily: 'system-ui, sans-serif' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                <h1 style={{ fontSize: 20, margin: 0 }}>{proj?.name}</h1>
                <span style={{ fontSize: 12, color: '#888' }}>
                    {(proj?.sourceLanguage || '').toUpperCase()} → {(proj?.targetLanguage || '').toUpperCase()}
                </span>
                <span style={{ flex: 1 }} />
                <div className="pv-seg">
                    {DEVICES.map((d) => (
                        <button
                            key={d.id}
                            type="button"
                            className={device === d.id ? 'on' : ''}
                            onClick={() => setDevice(d.id)}
                        >
                            {d.label}
                        </button>
                    ))}
                </div>
            </div>

            <div style={{ background: '#f4f5f7', borderRadius: 16, padding: 20, display: 'flex', justifyContent: 'center', minHeight: 500 }}>
                <div style={{
                    width: `min(${deviceWidth}px, 100%)`, background: '#fff',
                    borderRadius: 12, padding: '32px 40px', boxShadow: '0 6px 24px rgba(0,0,0,0.08)',
                }}>
                    {groups.map((group) => (
                        <PreviewFrame
                            key={group.frameId}
                            group={group}
                            structured={preview.structured}
                            sourceLang={proj?.sourceLanguage}
                            overlays={READONLY_OVERLAYS}
                            mutations={READONLY_MUTATIONS}
                            reference={READONLY_REFERENCE}
                            baseline={null}
                        />
                    ))}
                </div>
            </div>

            <p style={{ fontSize: 11, color: '#aaa', marginTop: 16, textAlign: 'center' }}>
                Read-only shared preview · {new Date().getFullYear()}
            </p>
        </div>
    );
};

export default SharedPreview;
